module.exports = __webpack_public_path__ + "img/倡议书.a28c4094.png";